"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configureMotion = exports.config = void 0;
const config = {
  timing: 'ms'
};
exports.config = config;
const configureMotion = function configureMotion(configuration) {
  Object.assign(config, configuration);
};
exports.configureMotion = configureMotion;
//# sourceMappingURL=configureMotion.js.map